import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";

export const subscribeEmail = async (email) => {
  const basePrefix = RAISE_API_V1_URL;
  const URL = `${basePrefix}/newsletter_signup`;
  await post(URL, {
    email,
    list: "Modal Users"
  });
};
